import { render, staticRenderFns } from "./OrderLog.vue?vue&type=template&id=6e87b1e4&scoped=true"
import script from "./OrderLog.vue?vue&type=script&lang=js"
export * from "./OrderLog.vue?vue&type=script&lang=js"
import style0 from "./OrderLog.vue?vue&type=style&index=0&id=6e87b1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87b1e4",
  null
  
)

export default component.exports